import { browserTimeZone, formatStoredInstant, normalizeTimeZone } from '../../../shared/app-timezone'

let timeZone = 'UTC'
const listeners = new Set()

export function setAppTimeZone (value) {

  timeZone = normalizeTimeZone(value)
  listeners.forEach(listener => listener(timeZone))
}

export function appTimeZone () {

  return timeZone
}

export function watchAppTimeZone (listener) {

  listeners.add(listener)

  return () => listeners.delete(listener)
}

export function formatAppInstant (value) {

  return formatStoredInstant(value, browserTimeZone())
}
